import { Component } from 'react'
import { captureAppError } from '../services/monitoringService'

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    captureAppError(error, {
      componentStack: errorInfo?.componentStack || null
    })
  }

  handleBackToDashboard = () => {
    if (typeof window === 'undefined') return
    window.location.hash = '#/student-dashboard'
    window.location.reload()
  }

  handleReload = () => {
    if (typeof window === 'undefined') return
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', background: '#111827', color: '#f9fafb', padding: '20px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
          <h1 style={{ marginBottom: '8px' }}>Une erreur est survenue</h1>
          <p style={{ marginTop: 0, opacity: 0.9 }}>
            L&apos;interface n&apos;a pas pu s&apos;afficher correctement. Tu peux recharger la page ou revenir au dashboard.
          </p>
          <div style={{ display: 'flex', gap: '10px', marginTop: '14px' }}>
            <button type="button" onClick={this.handleReload} style={{ border: '1px solid #374151', background: '#1f2937', color: '#f9fafb', padding: '10px 12px', borderRadius: '8px', cursor: 'pointer' }}>
              Recharger
            </button>
            <button type="button" onClick={this.handleBackToDashboard} style={{ border: '1px solid #4b5563', background: '#111827', color: '#f9fafb', padding: '10px 12px', borderRadius: '8px', cursor: 'pointer' }}>
              Retour dashboard
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default AppErrorBoundary

